import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const setActiveNavMenu = createAsyncThunk('navMenu/setActiveNavMenu', async (menuPath) => {
  return menuPath;
});

const initialState = {
  activeMenuPath: null
};

const navMenuSlice = createSlice({
  name: 'navMenu',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setActiveNavMenu.fulfilled, (state, action) => {
      state.activeMenuPath = action.payload;
    });
  }
});

export default navMenuSlice.reducer;
